// extracted by mini-css-extract-plugin
export var messageSideLeft = "_om-1";
export var stateContainer = "_om-0";